module.exports = __webpack_public_path__ + "media/images/mobile/solutions/bg23-f7267e8f54778c7ae2483a20f4cd34f6.png";